import { useState, useEffect } from 'react';
import axios from 'axios';

// Directly use the full URL as requested
const WEBHOOK_URL = 'https://n8n.srv1162400.hstgr.cloud/webhook/Avopla-chatbot';
const STORAGE_KEY = 'chat_messages';

// Create a dedicated axios instance to ensure no global config interferes
const chatClient = axios.create();

export const useChat = () => {
    const [messages, setMessages] = useState(() => {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved ? JSON.parse(saved) : [{
            id: 'welcome',
            text: 'Hello! How can I help you today?',
            sender: 'bot',
            timestamp: new Date().toISOString()
        }];
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    // Persist messages
    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(messages));
    }, [messages]);

    const toggleChat = () => setIsOpen(!isOpen);

    const sendMessage = async (text) => {
        if (!text.trim()) return;

        const userMessage = {
            id: Date.now().toString(),
            text,
            sender: 'user',
            timestamp: new Date().toISOString()
        };

        setMessages(prev => [...prev, userMessage]);
        setIsLoading(true);

        try {
            console.log('Sending message to webhook:', WEBHOOK_URL);

            // Using dedicated client with full URL
            const response = await chatClient.post(WEBHOOK_URL, {
                chatInput: text,
                sessionId: 'user-session-1'
            });

            console.log('Webhook response:', response.data);

            const data = response.data;
            let responseText = '';

            if (typeof data === 'string') {
                responseText = data;
            } else if (data.reply) {
                responseText = data.reply;
            } else if (data.output) {
                responseText = data.output;
            } else if (data.text) {
                responseText = data.text;
            } else {
                responseText = JSON.stringify(data);
            }

            // Cleanup: remove leading '=' if present
            if (responseText.startsWith('=')) {
                responseText = responseText.substring(1);
            }

            const botMessage = {
                id: (Date.now() + 1).toString(),
                text: responseText,
                sender: 'bot',
                timestamp: new Date().toISOString()
            };

            setMessages(prev => [...prev, botMessage]);
        } catch (error) {
            console.error('Error sending message:', error);
            let errorText = "Sorry, I'm having trouble connecting right now. Please try again later.";

            if (error.code === 'ERR_NETWORK') {
                errorText += " (Network Error: This might be due to CORS issues if the server doesn't allow cross-origin requests)";
            }

            const errorMessage = {
                id: (Date.now() + 1).toString(),
                text: errorText,
                sender: 'bot',
                timestamp: new Date().toISOString(),
                isError: true
            };
            setMessages(prev => [...prev, errorMessage]);
        } finally {
            setIsLoading(false);
        }
    };

    const clearChat = () => {
        if (window.confirm('Are you sure you want to clear the chat history?')) {
            const initialMessage = [{
                id: 'welcome',
                text: 'Hello! How can I help you today?',
                sender: 'bot',
                timestamp: new Date().toISOString()
            }];
            setMessages(initialMessage);
        }
    };

    return {
        messages,
        isLoading,
        isOpen,
        toggleChat,
        sendMessage,
        clearChat
    };
};
